import { Flex } from "@nulogy/components";
import styled from "styled-components";

const ModalFooter = styled(Flex)(({ theme }) => ({
  borderTop: `solid 1px ${theme.colors.lightGrey}`,
  paddingTop: theme.sizes.x2,
}));

export default ModalFooter;
